var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.loading && !_vm.proxy
        ? _c(
            "div",
            {
              staticClass: "py-6 text-center",
              attrs: {
                role: "status"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: "32",
                  width: "3"
                }
              }),
              _c(
                "span",
                {
                  staticClass: "kvm-sr-only"
                },
                [_vm._v("Loading domains…")]
              )
            ],
            1
          )
        : _vm.error
        ? _c(
            "v-alert",
            {
              attrs: {
                type: "error",
                border: "left",
                dense: "",
                role: "alert"
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.error) + " "),
              _c(
                "div",
                {
                  staticClass: "mt-2"
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        small: "",
                        tile: "",
                        outlined: "",
                        color: "primary"
                      },
                      on: {
                        click: _vm.load
                      }
                    },
                    [_vm._v("Retry")]
                  )
                ],
                1
              )
            ]
          )
        : _vm.proxy && !_vm.proxy.installed
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex align-start mb-3"
              },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-3",
                    attrs: {
                      size: "36",
                      color: "primary",
                      "aria-hidden": "true"
                    }
                  },
                  [_vm._v("mdi-web-check")]
                ),
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "body-1 font-weight-medium"
                    },
                    [_vm._v("Put your apps on real domains, with HTTPS")]
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "kvm-help mb-0"
                    },
                    [
                      _vm._v(" Visitors use "),
                      _c(
                        "span",
                        {
                          staticClass: "kvm-dk-mono"
                        },
                        [_vm._v("https://blog.example.com")]
                      ),
                      _vm._v(
                        " instead of an IP address and port, with a free, auto-renewing certificate. "
                      ),
                      _vm.proxy.free_domain
                        ? [
                            _vm._v(
                              " No domain? Every app can get a free one like "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "kvm-dk-mono"
                              },
                              [_vm._v("blog." + _vm._s(_vm.proxy.free_domain))]
                            ),
                            _vm._v(". ")
                          ]
                        : _vm._e(),
                      _vm._v(" This server needs a one-time setup first. ")
                    ],
                    2
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "d-flex flex-wrap align-start",
                staticStyle: {
                  "max-width": "560px"
                }
              },
              [
                _c("v-text-field", {
                  staticClass: "mr-2",
                  attrs: {
                    label: "Email for certificate notices",
                    type: "email",
                    outlined: "",
                    dense: "",
                    hint:
                      "Used for your HTTPS certificates (e.g. expiry notices). Not shared.",
                    "persistent-hint": ""
                  },
                  model: {
                    value: _vm.installEmail,
                    callback: function callback($$v) {
                      _vm.installEmail =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "installEmail"
                  }
                }),
                _c(
                  "gg-btn",
                  {
                    staticClass: "mt-1 kvm-dk-primary",
                    attrs: {
                      tile: "",
                      color: "primary",
                      loading: _vm.installing,
                      disabled: !_vm.installEmail
                    },
                    on: {
                      click: _vm.install
                    }
                  },
                  [_vm._v(" Set up domains ")]
                )
              ],
              1
            ),
            _c(
              "p",
              {
                staticClass: "kvm-help text-caption mt-2 mb-0"
              },
              [
                _vm._v(
                  "Ports 80 and 443 must be free — if an app already uses one of them, move it to another port first."
                )
              ]
            ),
            _vm.installError
              ? _c(
                  "v-alert",
                  {
                    staticClass: "mt-3 mb-0",
                    attrs: {
                      type: "warning",
                      dense: "",
                      text: "",
                      role: "alert"
                    }
                  },
                  [_vm._v(_vm._s(_vm.installError))]
                )
              : _vm._e()
          ]
        : _vm.proxy
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex flex-wrap align-center mb-3"
              },
              [
                _c(
                  "v-chip",
                  {
                    staticClass: "mr-2",
                    attrs: {
                      small: "",
                      label: "",
                      color: _vm.proxy.running
                        ? "green lighten-3"
                        : "grey lighten-2",
                      "text-color": "grey darken-4"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.proxy.running ? "Running" : "Stopped") +
                        " "
                    )
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "kvm-help text-caption mr-auto"
                  },
                  [
                    _vm._v(" Certificates for " + _vm._s(_vm.proxy.email)),
                    _vm.proxy.free_domain
                      ? [
                          _vm._v(" · free domain: "),
                          _c(
                            "span",
                            {
                              staticClass: "kvm-dk-mono"
                            },
                            [_vm._v("*." + _vm._s(_vm.proxy.free_domain))]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _c(
                  "gg-btn",
                  {
                    staticClass: "mr-2 mb-1",
                    attrs: {
                      small: "",
                      tile: "",
                      outlined: "",
                      color: "primary",
                      loading: _vm.loading
                    },
                    on: {
                      click: _vm.load
                    }
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          left: "",
                          small: "",
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v("mdi-refresh")]
                    ),
                    _vm._v("Refresh ")
                  ],
                  1
                ),
                _c(
                  "gg-btn",
                  {
                    staticClass: "mb-1 kvm-dk-primary",
                    attrs: {
                      small: "",
                      tile: "",
                      color: "primary"
                    },
                    on: {
                      click: _vm.openAdd
                    }
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          left: "",
                          small: "",
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v("mdi-plus")]
                    ),
                    _vm._v("Add domain ")
                  ],
                  1
                )
              ],
              1
            ),
            !_vm.proxy.routes.length
              ? _c(
                  "p",
                  {
                    staticClass: "kvm-help my-6 text-center"
                  },
                  [_vm._v("No domains yet. Add one to publish an app.")]
                )
              : _c(
                  "v-simple-table",
                  {
                    staticClass: "kvm-dk-table",
                    attrs: {
                      dense: ""
                    }
                  },
                  [
                    _c(
                      "caption",
                      {
                        staticClass: "kvm-sr-only"
                      },
                      [_vm._v("Domains")]
                    ),
                    _c("thead", [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            attrs: {
                              scope: "col"
                            }
                          },
                          [_vm._v("Domain")]
                        ),
                        _c(
                          "th",
                          {
                            attrs: {
                              scope: "col"
                            }
                          },
                          [_vm._v("Goes to")]
                        ),
                        _c(
                          "th",
                          {
                            attrs: {
                              scope: "col"
                            }
                          },
                          [_vm._v("DNS")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "text-right",
                            attrs: {
                              scope: "col"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "kvm-sr-only"
                              },
                              [_vm._v("Actions")]
                            )
                          ]
                        )
                      ])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.proxy.routes, function(r) {
                        return _c(
                          "tr",
                          {
                            key: r.hostname + r.path
                          },
                          [
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": "Domain"
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "kvm-dk-link",
                                    attrs: {
                                      href: _vm.routeUrl(r),
                                      target: "_blank",
                                      rel: "noopener"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.routeLabel(r)))]
                                )
                              ]
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": "Goes to"
                                }
                              },
                              [_vm._v(_vm._s(_vm.targetLabel(r.port)))]
                            ),
                            _c(
                              "td",
                              {
                                attrs: {
                                  "data-label": "DNS"
                                }
                              },
                              [
                                r.dns_ok === true
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "kvm-dk-ok"
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "kvm-dk-ok",
                                            attrs: {
                                              small: "",
                                              "aria-hidden": "true"
                                            }
                                          },
                                          [_vm._v("mdi-check-circle")]
                                        ),
                                        _vm._v(" OK")
                                      ],
                                      1
                                    )
                                  : r.dns_ok === false
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "kvm-dk-warn",
                                        attrs: {
                                          title:
                                            "Point an A record for this name to " +
                                            _vm.proxy.server_ip
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "kvm-dk-warn",
                                            attrs: {
                                              small: "",
                                              "aria-hidden": "true"
                                            }
                                          },
                                          [_vm._v("mdi-alert")]
                                        ),
                                        _vm._v(" Not pointing here yet ")
                                      ],
                                      1
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass: "kvm-help"
                                      },
                                      [_vm._v("—")]
                                    )
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass: "text-right",
                                attrs: {
                                  "data-label": "Actions"
                                }
                              },
                              [
                                _c(
                                  "gg-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      small: "",
                                      "aria-label":
                                        "Remove " + _vm.routeLabel(r),
                                      disabled:
                                        _vm.removing === _vm.routeLabel(r)
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.removeRoute(r)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          small: "",
                                          color: "error"
                                        }
                                      },
                                      [_vm._v("mdi-delete-outline")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ),
            _vm.proxy.routes.some(function(r) {
              return r.dns_ok === false
            })
              ? _c(
                  "p",
                  {
                    staticClass: "kvm-help text-caption mt-2 mb-0"
                  },
                  [
                    _vm._v(" For your own domains, add a DNS "),
                    _c("strong", [_vm._v("A record")]),
                    _vm._v(" pointing to "),
                    _c(
                      "span",
                      {
                        staticClass: "kvm-dk-mono"
                      },
                      [_vm._v(_vm._s(_vm.proxy.server_ip))]
                    ),
                    _vm._v(
                      ". HTTPS starts working a minute or two after DNS updates. "
                    )
                  ]
                )
              : _vm._e()
          ]
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "560",
            persistent: ""
          },
          model: {
            value: _vm.add.open,
            callback: function callback($$v) {
              _vm.$set(_vm.add, "open", $$v)
            },
            expression: "add.open"
          }
        },
        [
          _c(
            "gg-card",
            {
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "kvm-dk-add-title"
              }
            },
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "h3",
                    {
                      staticClass: "body-1 font-weight-medium mb-3",
                      attrs: {
                        id: "kvm-dk-add-title"
                      }
                    },
                    [_vm._v("Add a domain")]
                  ),
                  _c(
                    "v-radio-group",
                    {
                      staticClass: "mt-0 mb-3",
                      attrs: {
                        row: "",
                        dense: "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.add.kind,
                        callback: function callback($$v) {
                          _vm.$set(_vm.add, "kind", $$v)
                        },
                        expression: "add.kind"
                      }
                    },
                    [
                      _vm.proxy && _vm.proxy.free_domain
                        ? _c("v-radio", {
                            attrs: {
                              label: "Free subdomain",
                              value: "free"
                            }
                          })
                        : _vm._e(),
                      _c("v-radio", {
                        attrs: {
                          label: "One of my domains",
                          value: "mine"
                        }
                      }),
                      _c("v-radio", {
                        attrs: {
                          label: "Another domain",
                          value: "own"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.add.kind === "free"
                    ? _c("v-text-field", {
                        staticClass: "mb-2",
                        attrs: {
                          label: "Subdomain",
                          placeholder: "blog",
                          outlined: "",
                          dense: "",
                          suffix: "." + (_vm.proxy && _vm.proxy.free_domain),
                          "persistent-hint": "",
                          hint:
                            "Each app gets its own address, so several apps can share this server."
                        },
                        model: {
                          value: _vm.add.name,
                          callback: function callback($$v) {
                            _vm.$set(
                              _vm.add,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "add.name"
                        }
                      })
                    : _vm.add.kind === "mine"
                    ? _c("kvm-own-domain", {
                        attrs: {
                          "server-ip": _vm.proxy && _vm.proxy.server_ip
                        },
                        model: {
                          value: _vm.add.mine,
                          callback: function callback($$v) {
                            _vm.$set(_vm.add, "mine", $$v)
                          },
                          expression: "add.mine"
                        }
                      })
                    : _c("v-text-field", {
                        staticClass: "mb-2",
                        attrs: {
                          label: "Domain",
                          placeholder: "blog.example.com",
                          outlined: "",
                          dense: "",
                          "persistent-hint": "",
                          hint:
                            "Point its DNS A record to " +
                            (_vm.proxy && _vm.proxy.server_ip) +
                            " for HTTPS to work."
                        },
                        model: {
                          value: _vm.add.hostname,
                          callback: function callback($$v) {
                            _vm.$set(
                              _vm.add,
                              "hostname",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "add.hostname"
                        }
                      }),
                  _c("v-text-field", {
                    staticClass: "mb-2",
                    attrs: {
                      label: "Path",
                      placeholder: "/",
                      outlined: "",
                      dense: "",
                      "persistent-hint": "",
                      hint:
                        "/ is the whole domain. Use a path like /blog to put several apps on one domain (the app must support running under a path)."
                    },
                    model: {
                      value: _vm.add.path,
                      callback: function callback($$v) {
                        _vm.$set(
                          _vm.add,
                          "path",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "add.path"
                    }
                  }),
                  _c("v-combobox", {
                    staticClass: "mb-2",
                    attrs: {
                      items: _vm.portItems,
                      "item-text": "text",
                      "item-value": "value",
                      "return-object": false,
                      label: "App",
                      outlined: "",
                      dense: "",
                      "persistent-hint": "",
                      hint:
                        "Pick a container's published port, or type a port number"
                    },
                    model: {
                      value: _vm.add.port,
                      callback: function callback($$v) {
                        _vm.$set(_vm.add, "port", $$v)
                      },
                      expression: "add.port"
                    }
                  }),
                  _vm.add.error
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            type: "warning",
                            dense: "",
                            text: "",
                            role: "alert"
                          }
                        },
                        [_vm._v(_vm._s(_vm.add.error))]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "text-right mt-3"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            text: "",
                            disabled: _vm.add.saving
                          },
                          on: {
                            click: function click($event) {
                              _vm.add.open = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          staticClass: "kvm-dk-primary",
                          attrs: {
                            tile: "",
                            color: "primary",
                            loading: _vm.add.saving,
                            disabled: !_vm.addHostname || !_vm.add.port
                          },
                          on: {
                            click: _vm.saveRoute
                          }
                        },
                        [_vm._v("Add")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }